import { useTranslation } from '@frontend/i18n';
import { DropdownField, useFormField } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  label: string;
  name: string;
  onChange: (value: string | undefined) => void;
  options: string[];
  resetKey: number;
  value: string | undefined;
};

export const DropdownFilter = ({ label, name, onChange, options, resetKey, value }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();
  const trackingId = `${label.toLowerCase().split(' ').join('-')}-filter-input`;
  const dropdownField = useFormField({ type: 'dropdown', value }, [resetKey]);

  return (
    <DropdownField
      {...dropdownField}
      onChange={(e) => {
        dropdownField.onChange(e);
        onChange(e.value);
      }}
      label={label}
      name={name}
      data-testid={trackingId}
      data-trackingid={`${trackingIdPrefix}-${trackingId}`}
    >
      <DropdownField.Option value={''}>{t('Select one')}</DropdownField.Option>
      {options?.map((option, index) => (
        <DropdownField.Option key={index} value={option as string}>
          {option}
        </DropdownField.Option>
      ))}
    </DropdownField>
  );
};
